module.exports = __webpack_public_path__ + "media/hero-video.da601551.mp4";